// import React from "react";
// import "./TPMS_2.css";

// function TPMS_2() {
//   return (
//     <div className="tpms2-top-section">

//       <section className="tpms2-hero">

//         <div className="tpms2-hero-left px-5">

//           <h1 className="tpms2-title">
            
//             <span>AI-Powered TPMS</span>
//           </h1>

//           <p className="tpms2-desc text-justify">
//             Smart IoT-based tyre pressure monitoring system designed to
//             improve toll operations, increase vehicle safety, reduce downtime
//             and enhance real-time analytics for better decision making.
//           </p>

//           <div className="tpms2-buttons">
//             <button className="tpms2-demo-btn">Get Live Demo</button>
//             <button className="tpms2-video-btn tpms2-demo-btn">Talk to Expert</button>
//           </div>

//         </div>

//         <div className="tpms2-hero-right">

         
//     <div>
//         <img
//         src="ImagesNew/TPMS_imgg.jpg"
//         alt="tpms_img"
//         className="rounded-3 "
//         />
//         </div>
//         </div>

//       </section>

//       <section className="tpms2-stats">

//         <div className="tpms2-stats-box">
//           <h3>97%</h3>
//           <p>Accuracy</p>
//         </div>

//         <div className="tpms2-stats-box">
//           <h3>21s</h3>
//           <p>Response Time</p>
//         </div>

//         <div className="tpms2-stats-box">
//           <h3>25%</h3>
//           <p>Fuel Saving</p>
//         </div>

//         <div className="tpms2-stats-box">
//           <h3>120+</h3>
//           <p>Fleet Monitoring</p>
//         </div>

//         <div className="tpms2-stats-box">
//           <h3>100%</h3>
//           <p>Safety</p>
//         </div>

//       </section>

//     </div>
//   );
// }

// export default TPMS_2;

import React from "react";
import "./TPMS_2.css";

/* ============================================================
   IMAGE – screenshot wali same image yahan lagao
   (public/TPMS_img/ me rakho, path me "public" nahi likhna)
   ============================================================ */
const HERO_IMAGE = "/ImagesNew/dashboard-LR-1.jpeg";

/* buttons ke links – apne routes se badal lo */
const LINKS = {
  demo: "#demo",
  features: "#features",
};

const CONTENT = {
  eyebrow: "Toll Plaza Monitoring System",
  title: "AI-Powered TPMS",
  paragraphs: [
    "Modern toll plazas process thousands of vehicles daily, yet traditional monitoring systems can struggle with missed vehicles, incorrect classifications, fraudulent transactions, excessive vehicle exemptions, and insufficient evidence for operational audits.",
  ],
  definition: {
    strong: "TPMS (Toll Plaza Monitoring System)",
    rest: " is an AI-powered software solution designed to improve vehicle monitoring, prevent revenue leakage, strengthen accountability, and enhance toll plaza operational efficiency.",
  },
  cameras:
    "Using existing toll plaza cameras, TPMS automatically detects and tracks vehicles, captures visual evidence, generates vehicle records, and provides centralized monitoring without requiring additional roadside cameras or dedicated vehicle-detection sensors.",
  tagline: ["Monitor Smarter.", "Reduce Revenue Leakage.", "Strengthen Accountability."],
};

const TPMSHero = () => (
  <section className="th"> 
    <div className="th__container">
      {/* ---------- left content ---------- */}
      <div className="th__content">
        <span className="th__eyebrow">{CONTENT.eyebrow}</span>
        <h1 className="th__title">{CONTENT.title}</h1>

        {CONTENT.paragraphs.map((p) => (
          <p key={p} className="th__text">
            {p}
          </p>
        ))}

        <p className="th__text">
          <strong>{CONTENT.definition.strong}</strong>
          {CONTENT.definition.rest}
        </p>

        <p className="th__text">{CONTENT.cameras}</p>

        <p className="th__tagline">
          {CONTENT.tagline.map((t) => (
            <span key={t}>{t}</span>
          ))}
        </p>

        <div className="th__actions">
          <a href={LINKS.demo} className="th__btn th__btn--primary">
            Request a Demo
          </a>
          <a href={LINKS.features} className="th__btn th__btn--outline">
            Explore Features
          </a>
        </div>
      </div>

      {/* ---------- right image ---------- */}
      <div className="th__media">
        <div className="th__frame">
          <img
            src={HERO_IMAGE}
            alt="TPMS toll plaza analytics dashboard with AI camera feed"
            className="th__image"
          />
        </div>
      </div>
    </div>
  </section>
);

export default TPMSHero;